import { useSelector } from "react-redux";
import DroneStreamViewer, { STREAM_BASE_URL } from "./DroneStreamViewer";
import { useT } from "../../i18n";

/**
 * StreamFloat
 * ------------------------------------------------------------
 * 지도 우하단(줌 도구 왼쪽)에 뜨는 플로팅 라이브 스트림.
 * 드론이 실제로 스트리밍 중(droneData.streaming === "ON")일 때만 나타나고,
 * 아니면 아무것도 렌더하지 않는다.
 */
export default function StreamFloat() {
  const t = useT();
  const serialNum = useSelector(
    (state) => state.drone.control?.serialNum ?? ""
  );
  const streaming = useSelector(
    (state) => state.drone.droneData?.streaming ?? null
  );

  const isLive = String(streaming ?? "").trim().toUpperCase() === "ON";
  const hasStream = Boolean(STREAM_BASE_URL && serialNum.trim());

  // 위치 확인용 임시 플래그 — true 로 바꾸면 스트리밍이 없어도 강제 표시된다.
  const FORCE_SHOW_FOR_TEST = false;

  if (!FORCE_SHOW_FOR_TEST && (!hasStream || !isLive)) return null;

  return (
    <div className="calm-stream-float">
      <DroneStreamViewer serialNum={serialNum} isLive title={t("common.stream.liveTitle")} />
    </div>
  );
}
